import { VStack, Text, Divider, Button, Box } from "@chakra-ui/react";
import L from "leaflet";
import { GeoJSON, Popup } from "react-leaflet";
import { GeoJsonObject, FeatureCollection } from "geojson";
import complaintPin from "_assets/imgs/mapa/markers/map-icon-red.png";
import { useState } from "react";
import { Manifestacao } from "store/modules/ouvidoria/manifestacoes/actions/getManifestacoesGeojson";
import { useVerManifestacao } from "../contexts/VerManifestacaoProvider";

const complaintPinIcon = new L.Icon({
  iconUrl: complaintPin,
  iconSize: [30.48, 50],
  iconAnchor: [15.24, 50],
  shadowSize: [61, 61]
});

type PopupManifestacao = Manifestacao & { lat: number; lng: number };

export function ManifestacaoGeojson({
  featureCollection
}: {
  featureCollection: FeatureCollection<GeoJSON.Point, Manifestacao>;
}) {
  const [popup, setPopup] = useState<PopupManifestacao | null>(null);
  const { setIdManifestacao } = useVerManifestacao();

  return (
    <>
      <GeoJSON
        key={JSON.stringify(featureCollection)}
        data={featureCollection as GeoJsonObject}
        pointToLayer={(_, latlng) => {
          return L.marker(latlng, { icon: complaintPinIcon });
        }}
        eventHandlers={{
          click: (f) => {
            setPopup({
              ...f.layer.feature.properties,
              lat: f.latlng.lat,
              lng: f.latlng.lng
            });
          }
        }}
      />
      {popup && (
        <Popup
          position={{
            lat: popup.lat,
            lng: popup.lng
          }}
          offset={[0, -40]}
          onClose={() => setPopup(null)}
          minWidth={250}
        >
          <VStack p={4} justify="flex-start" align="flex-start">
            <Text fontSize="xl" fontWeight="semibold">
              Manifestação
            </Text>
            <Text fontSize="md" fontWeight="medium">
              {popup.titulo}
            </Text>
            <Divider my={1} />
            <Text fontSize="sm">{popup.name}</Text>
            <Box pt="2" w="full">
              <Button
                size="sm"
                w="full"
                colorScheme="main"
                onClick={() => setIdManifestacao(popup.id)}
              >
                Ver manifestação
              </Button>
            </Box>
          </VStack>
        </Popup>
      )}
    </>
  );
}
